import { Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import useUser from 'hooks/useUser';

interface RangeData {
  label?: string;
  lowerLimit?: number;
  upperLimit?: number;
}

interface PreciseData {
  label?: string;
  value?: number;
}

interface Props {
  headers?: Array<string>;
  data?: RangeData[] | PreciseData[];
  type?: string;
  itemLabel?: string;
  itemLabelFrench?: string;
}

const LegendTable = ({ data, headers, type, itemLabel, itemLabelFrench }: Props) => {
  const { userId } = useAuth();
  const { user } = useUser(userId);
  return (
    <Stack>
      <Typography variant="h4">{user?.preferredLanguage === 'english' ? itemLabel : itemLabelFrench || itemLabel}</Typography>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          {headers?.map((header) => (
            <TableCell>{header}</TableCell>
          ))}
        </TableHead>
        <TableBody>
          {data?.map((ele) => (
            <TableRow>
              <TableCell>{user?.preferredLanguage === 'french' ? ele?.labelFrench || ele?.label : ele?.label}</TableCell>
              {type === 'precise' ? (
                <TableCell>{ele?.value}</TableCell>
              ) : (
                <>
                  <TableCell>{ele?.lowerLimit}</TableCell>
                  <TableCell>{ele?.upperLimit}</TableCell>
                </>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default LegendTable;
